/**
 * Функция склонения слова для числительного, будет работать с числом любой длинны(112, 1031 и т.д)
 * @param {number} count - Числительное
 * @param {string} one - Вариант слова для цифры один (например: 1 "проект", "курс")
 * @param {string} two - Вариант слова от 2 до 4-х (например: 2 "проекта", "курса")
 * @param {string} five - Вариант слова от 5 до 20-ти (например: 5 "проектов", "курсов")
 * @returns {string} Склоненное слово в зависимости от числительного
 */

export default function declinationOfNumber(count, one, two, five) {
    const n100 = Math.abs(count) % 100;
    const n10 = n100 % 10;

    if (n100 >= 5 && n100 <= 20) {
        return five;
    }
    if (n10 > 1 && n10 < 5) {
        return two;
    }
    if (n10 === 1) {
        return one;
    }
    return five;
}